import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api`;

export const listPages = async () => {
  const res = await axios.get(`${API}/pages`, { withCredentials: true });
  return res.data;
};

export const getPage = async (slug) => {
  const res = await axios.get(`${API}/pages`, { params: { slug }, withCredentials: true });
  return res.data;
};

export const savePage = async (payload, token) => {
  const res = await axios.post(`${API}/admin/pages/save`, payload, {
    withCredentials: true,
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
  return res.data;
};

export const deletePage = async (slug, token) => {
  const res = await axios.delete(`${API}/admin/pages/${slug}`, {
    withCredentials: true,
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
  return res.data;
};